import isArray from 'lodash/isArray';

const mergeArrayCustomizer = (a: unknown, b: unknown) =>
  isArray(b) ? b : undefined;

export default mergeArrayCustomizer;
